var map = {
	"./amazon.png": 211,
	"./electronicscomp.png": 37,
	"./evelta.png": 52,
	"./flipkart.png": 304,
	"./quartz.png": 410,
	"./robocraze.png": 648,
	"./robu.png": 321,
	"./thingbits.png": 883
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49;